export default "/fonts/vendor/katex/dist/KaTeX_Size4-Regular.woff2?e418bf257af1052628d8c981d158674c";